import React, { useState, useContext, useEffect } from "react";
import "../../../../stylesheet/forms.css";
import { RiCloseLine } from "react-icons/ri";
import { addBilling, editBilling, deleteBilling } from "../../../../Utils/localStore";
import ToastContext from "../../../../context/toasterContex";

const NewInvoice = ({ onClose, update, edit, details }) => {
  const { toast } = useContext(ToastContext)
  const [BillindData, setBillingData] = useState({
    userLocalId: details.localID
  })
  // const notesForm = useRef(null)
  let today = Date.now()
  const formatter = new Intl.DateTimeFormat('en-NG', {
    dateStyle: 'full',
    timeStyle: 'long',
  })
  today = formatter.format(today);
  const handleFormUpdate = (e) => {
    const { id, value } = e.target
    setBillingData({
      ...BillindData,
      date: today,
      [id]: value
    })
  }
  const handleFormSubmit = async (e) => {
    e.preventDefault()

    if (!edit) {
      const newBilling = { ...BillindData, date: today, staus: 'Unpaid' }
      console.log({ newBilling });
      await addBilling(newBilling)
        .then(resp => {
          update()
          toast.success('Invoice Added successfully', { position: toast.POSITION.TOP_CENTER })
        })
        .catch(err => {
          toast.error('Something went wrong, please try again later', { position: toast.POSITION.TOP_CENTER })
          throw new Error(err)
        })
    } else {
      await editBilling(BillindData)
        .then(resp => {
          update()
          toast.success('Invoice updated successfully', { position: toast.POSITION.TOP_CENTER })
        })
        .catch(err => {
          console.log({ err });
          toast.error('Something went wrong, please try again later', { position: toast.POSITION.TOP_CENTER })
          throw new Error(err)
        })
    }
    onClose(e)
  }
  useEffect(() => {
    if (edit) {
      setBillingData(details)
    }
  }, []);
  return (
    <>
      <dialog >
        <div className="w-[700px] bg-white rounded-md border relative">
          <section className="font-euclid-circular-a w-full relative">
            <div className="w-full bg-primary rounded-t-md" >
              <div className="flex justify-between w-full align-middle">
                <h2 className="text-white text-xl font-semibold leading-7 tracking-wide p-8">
                  {
                    !edit ? 'Create Invoice' : 'Edit Invoice'
                  }
                </h2>
                <div className="leading-7 text-xl font-semibold  p-8">
                  <button onClick={onClose}> <RiCloseLine color="white" size={30} /> </button>
                </div>
              </div>
            </div>
          </section>
          <section className="font-euclid-circular-a w-full p-8">
            {/* <div className="w-[700px] h-[0px] border border-zinc-800 border-opacity-20" /> */}
            <form onSubmit={(e) => handleFormSubmit(e)} id="appt_form3" className="appt_form">
              <label htmlFor="name">Name of client</label>
              <input
                id="name"
                type="text"
                name="name"
                defaultValue={BillindData.name || ''}
                onChange={(e) => handleFormUpdate(e)}
                placeholder="Audrey Freeborn"
              />
              <label htmlFor="description">Description</label>
              <textarea
                id="description"
                defaultValue={BillindData.description || ''}
                onChange={(e) => handleFormUpdate(e)}
                className="h-[118px]"
                placeholder="Enter a description..."
              />
              <label htmlFor="department">Responsible department</label>
              <input
                id="department"
                defaultValue={BillindData.department || ''}
                onChange={(e) => handleFormUpdate(e)}
                type="text"
                name="department"
                placeholder="Enter responsible department"
              />
              <label htmlFor="amount">Amount</label>
              <div className="flex items-center amount_input">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M7 18V7.052C6.99993 6.81932 7.07715 6.59322 7.21952 6.40919C7.36189 6.22515 7.56136 6.09363 7.7866 6.03526C8.01183 5.97689 8.25008 5.99499 8.46391 6.08671C8.67774 6.17843 8.85506 6.33858 8.968 6.542L15.032 17.458C15.1449 17.6614 15.3223 17.8216 15.5361 17.9133C15.7499 18.005 15.9882 18.0231 16.2134 17.9647C16.4386 17.9064 16.6381 17.7748 16.7805 17.5908C16.9229 17.4068 17.0001 17.1807 17 16.948V6M5 10H19M5 14H19"
                    stroke="#4D4D4D"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <input id="amount" type="text" name="amount"
                  defaultValue={BillindData.amount || ''}
                  onChange={(e) => handleFormUpdate(e)} />
              </div>
              <label htmlFor="date">Due Date</label>
              <div className="custom_date">
                <input
                  className="date_input"
                  type="date"
                  defaultValue={BillindData.dueDate || ''}
                  onChange={(e) => handleFormUpdate(e)}
                  id="dueDate"
                  name="dueDate"
                  placeholder="DD/MM/YYYY"
                />
              </div>
              <div className="flex justify-end mt-3">
                <button type="submit" className="document_button">Continue</button>
              </div>
            </form>
          </section>
        </div>
      </dialog>
    </>
  );
};

export default NewInvoice;
